export * from './Icon';
export * from './types';
export * from './ColorIcon';

export { default } from './Icon';
